
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFA69D","width":"20","height":"20","rx":"10"}}),_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M4 4h12v12H4z"}}),_c('path',{attrs:{"d":"M6 12a.5.5 0 110 1 .5.5 0 010-1zm8 0a.5.5 0 110 1H8a.5.5 0 010-1h6zM6 9.5a.5.5 0 110 1 .5.5 0 010-1zm8 0a.5.5 0 110 1H8a.5.5 0 010-1h6zM6 7a.5.5 0 110 1 .5.5 0 010-1zm8 0a.5.5 0 110 1H8a.5.5 0 010-1h6z","fill":"#001C45"}})])])
          )
        }
      }
    